export default __webpack_public_path__ + "static/media/evaluation.76b2dd83.svg";